export var CustomizedDashboardsRoutes = {
    "/dashboards": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.custom-dashboards",
        "type": "frontend",
        "component": "dashboardsContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["customized_dashboards"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./customized-dashboards.module.js");
                }
            }
        ],
        "onEnter": ['$state', 'brandServices', 'hUser', '$q',
            function ($state, brandServices, hUser, $q) {
                var defer = $q.defer();
                var brandIds = _.pluck(hUser.data.user.brands_list, 'id');
                if (brandIds.length !== 1) {
                    brandIds.push(hUser.getUserContext()['brand_id']);
                }
                brandServices
                    .check(brandServices.SERVICES.CUSTOM_DASHBOARD, brandIds[0], true)
                    .then(function (isCustomDashEnabled) {
                        if (!isCustomDashEnabled || !hUser.hasSalesAccess()) {
                            Utils.redirectToWorkspace("homepage");
                            defer.reject();
                        } else {
                            defer.resolve();
                        }
                    });
                return defer.promise;
            }
        ]
    }
};
